import { render, staticRenderFns } from "./RecommendationsTable.vue?vue&type=template&id=cde0c2dc&scoped=true&"
import script from "./RecommendationsTable.vue?vue&type=script&lang=js&"
export * from "./RecommendationsTable.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationsTable.vue?vue&type=style&index=0&id=cde0c2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde0c2dc",
  null
  
)

export default component.exports